"use client";
import { useNotificationError } from "@/context/error-provider";
import { ErrorNotificationComponent } from "@/pages/components/error-notification";

export function ErrorNotificationContainer() {
  const { errors, removeError } = useNotificationError();

  if (errors.length === 0) {
    return null;
  }

  return (
    <div className="pointer-events-none fixed right-4 top-4 z-[110] space-y-3">
      {errors.map((error) => (
        <div key={error.id} className="pointer-events-auto">
          <ErrorNotificationComponent error={error} onDismiss={removeError} />
        </div>
      ))}
    </div>
  );
}
